import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import moment from 'moment';
import { CarStatus } from 'store/slices/cars/types';

const UpcomingActionsSelector = (state: RootState) => state.upcomingActions;

export const selectAllUpcomingActions = createSelector(
  UpcomingActionsSelector,
  (state) => {
    return [...state.items]
      .filter((item) => item.car?.status !== CarStatus.DRAFT)
      .sort((a, b) => {
        const aDaysRemaining = moment(a.date).diff(moment(), 'd');
        const bDaysRemaining = moment(b.date).diff(moment(), 'd');

        return aDaysRemaining - bDaysRemaining;
      });
  },
);

export const selectUpcomingActionsPendingStatus = createSelector(
  UpcomingActionsSelector,
  (state) => state.isPending,
);
